import React from 'react'

export default function useEffectAfterMount(effect, dependencies) {
  const didMountRef = React.useRef(false)

  React.useEffect(() => {
    if (didMountRef.current) {
      effect()
    } else {
      didMountRef.current = true
    }
  }, dependencies) // eslint-disable-line react-hooks/exhaustive-deps
}
